import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ClearOutline = function ClearOutline(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.30603 9.78315C7.89799 9.37512 7.89799 8.71357 8.30603 8.30554C8.71406 7.8975 9.37561 7.8975 9.78364 8.30554L12.0004 10.5223L14.2165 8.30624C14.6245 7.89821 15.2861 7.89821 15.6941 8.30624C16.1021 8.71427 16.1021 9.37583 15.6941 9.78386L13.478 11.9999L15.6941 14.216C16.1021 14.624 16.1021 15.2856 15.6941 15.6936C15.2861 16.1017 14.6245 16.1017 14.2165 15.6936L12.0004 13.4775L9.78364 15.6943C9.37561 16.1024 8.71406 16.1024 8.30602 15.6943C7.89799 15.2863 7.89799 14.6247 8.30602 14.2167L10.5228 11.9999L8.30603 9.78315Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
    fill: color
  }));
};

export { ClearOutline };
